import { createSlice } from "@reduxjs/toolkit";

export const myAccountPageSlice = createSlice({
    name: "myAccountPage",
    initialState: {
        isLoading: false,
        isError: false,
        data: [],
        message: "",
        isgetLoading: true,
    },
    reducers: {
        onGetMyAccountSection: (state) => {
            return {
                ...state,
                isgetLoading: true,
                getData: [],
                getmessage: "",
            };
        },

        onGetMyAccountSectionSuccess: (state, { payload }) => {
            const { data = [], message = "", status_code = 200 } = payload;
            return {
                ...state,
                isgetLoading: false,
                getData: data,
                getmessage: message,
                get_status_code: status_code,
            };
        },

        onGetMyAccountSectionError: (state, { payload }) => {
            const { data = [], message = "", status_code = 400 } = payload;
            return {
                ...state,
                getData: data,
                getmessage: message,
                get_status_code: status_code,
                isgetLoading: false,
            };
        }
    }
});

export const {
    onGetMyAccountSection,
    onGetMyAccountSectionSuccess,
    onGetMyAccountSectionError
} = myAccountPageSlice.actions;

export default myAccountPageSlice.reducer;